import React, {Component} from 'react';

export default class AppliedFilter extends Component {
    clearFilters() {
        this.props.filter.remove(this.props.filter.filter);
    }

    render() {
        return (
            <div className="applied-filter">
                <span className="filter-tag">
                    <span className="label text-muted">{this.props.filter.name}</span>
                    <button type="button" className="close" aria-label="Close" onClick={this.clearFilters.bind(this)}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/appliedFilters/AppliedFilter.js